import { adFreeImage } from "@/mocks/home";

export default function AdFree() {
  const points = [
    {
      icon: "ri-forbid-2-line",
      title: "播放中减少贴片",
      desc: "尽量把时间留给剧情本身，一集看下来不需要反复等待倒计时。",
    },
    {
      icon: "ri-window-line",
      title: "干扰性弹窗更少",
      desc: "观看过程中尽量不弹出遮挡画面的提示，减少误触和打断。",
    },
    {
      icon: "ri-equalizer-line",
      title: "节奏更连贯",
      desc: "悬疑、剧情类作品对节奏敏感，少一次打断，观感会完整很多。",
    },
  ];

  return (
    <section id="noads" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative w-full h-[260px] md:h-[400px] rounded-lg overflow-hidden order-2 lg:order-1">
            <img
              src={adFreeImage}
              alt="在昏暗的家庭影院中安静观看的情景"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-accent-700">
              <i className="ri-shield-check-line"></i>
              无广告观看
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              把注意力还给剧情
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              无广告观看并不是一句口号，而是围绕播放过程做的取舍：尽量去掉贴片等待与遮挡画面的弹窗，
              让一段故事可以连贯地讲完。对于需要沉浸感的悬疑和剧情作品，这一点尤其重要。
            </p>

            <ul className="mt-7 space-y-4">
              {points.map((point) => (
                <li
                  key={point.title}
                  className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-4"
                >
                  <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 shrink-0">
                    <i className={`${point.icon} text-lg`}></i>
                  </span>
                  <div>
                    <p className="text-sm md:text-base font-medium text-foreground-950">
                      {point.title}
                    </p>
                    <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">
                      {point.desc}
                    </p>
                  </div>
                </li>
              ))}
            </ul>

            <p className="mt-5 text-xs text-foreground-500 leading-relaxed">
              说明：不同片源由不同线路提供，实际播放体验可能存在差异，请以播放页当时的情况为准。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}